






















import { Component, Vue, Prop } from 'vue-property-decorator'
import { AddAlarm } from '../store/alarm'

@Component
export default class AlarmForm extends Vue {
  @Prop() title!: string
  @Prop({ default: () => ({}) }) placeholder!: AddAlarm

  name = this.placeholder.name || ''
  nameRules = [(v: string) => !!v || 'Name is required']

  description = this.placeholder.description || ''
  valid = false

  submit() {
    this.$emit('submit', {
      name: this.name,
      description: this.description
    })
  }
  cancel() {
    this.$emit('cancel')
  }
}
